export const sygnet = [
  "160 160",
  `<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="3138.000000pt" height="573.000000pt" viewBox="0 0 3138.000000 573.000000"
 preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,573.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
</g>
</svg>
`,
];
